export const SOURCE_ROW_ZX_INDEX_RECORD_ID = 'zx_index';

export const SOURCE_ROWS_TABLE_HEADER = 'SOURCE_ROWS_TABLE_HEADER';
export const SOURCE_ROW_TITLE     = 'SOURCE_ROW_TITLE';
export const SOURCE_ROW_DATE      = 'SOURCE_ROW_DATE';
export const SOURCE_ROW_SOURCE    = 'SOURCE_ROW_SOURCE';
export const SOURCE_ROW_SIZE      = 'SOURCE_ROW_SIZE';
export const SOURCE_ROW_PRICE     = 'SOURCE_ROW_PRICE';
export const SOURCE_ROW_WEIGHTING = 'SOURCE_ROW_WEIGHTING';
export const SOURCE_TOTALS_ROW    = 'SOURCE_TOTALS_ROW';
export const SOURCE_TOTALS_ROW_TARGET = `${SOURCE_TOTALS_ROW}_target`;

// Field-prefix aliases for per-row cells. Do not use a bare `SOURCE_ROW_` match —
// customRowConfig also builds title-row aliases of the form `SOURCE_ROW_${rowKey}`.
export const SOURCE_ROW_FIELD_ALIASES = [
  SOURCE_ROW_TITLE,
  SOURCE_ROW_DATE,
  SOURCE_ROW_SOURCE,
  SOURCE_ROW_SIZE,
  SOURCE_ROW_PRICE,
  SOURCE_ROW_WEIGHTING,
] as const;

// Metadata fields: edits here cannot change the Target Price Per Share, so they must not
// trigger an equity value recalculation.
export const SOURCE_ROW_DESCRIPTIVE_ALIASES = [
  SOURCE_ROW_TITLE,
  SOURCE_ROW_DATE,
  SOURCE_ROW_SOURCE,
  SOURCE_ROW_SIZE,
] as const;
